import { ref, computed } from 'vue';

export function useApplyTariffToListTable(useSelection) {
	const selectedRowKeys = ref([]);
	const rowSelection = computed(() => {
		if (!useSelection) {
			return null;
		}
		return {
			selectedRowKeys,
			onChange: selectedKeys => {
				selectedRowKeys.value = selectedKeys;
			},
		};
	});
	const resetSelection = () => selectedRowKeys.value = [];
	const selectedCount = computed(() => selectedRowKeys.value.length);
	return {
		rowSelection,
		selectedRowKeys,
		selectedCount,
		resetSelection,
	};
}
